import { IconBell, IconX } from '@tabler/icons-react';
import { useState } from 'react';

import { usePodpiskaNaPush } from './push';

/**
 * ПЛАШКА «ВКЛЮЧИТЬ УВЕДОМЛЕНИЯ» (владелец, 18.09.2026, `s615`, с боевого телефона).
 *
 * ⛔⛔ ПОЧЕМУ ОТДЕЛЬНАЯ ПЛАШКА, А НЕ ОДИН КОЛОКОЛЬЧИК. Колокольчик в шапке
 * (`s608`) — тумблер для того, кто уже знает, что уведомления бывают. Человек,
 * впервые поставивший значок на главный экран, не знает: значок в шапке
 * выглядит как «показать уведомления», а не как «разрешить их присылать».
 * Дежурный закрывал лайт, ничего не нажав, и пуш не приходил никогда —
 * выключенным его не считал никто, потому что никто его и не включал.
 *
 * ⛔ РАЗРЕШЕНИЕ СПРАШИВАЕТСЯ СТРОГО ПО ТАПУ. Браузер телефона показывает окно
 * разрешения ОДИН раз: спроси его на открытии экрана — человек отмахнётся не
 * глядя, и вернуть вопрос будет уже нечем (то же правило, что у колокольчика,
 * `push.ts`). Поэтому плашка сама ничего не спрашивает: она только видна.
 *
 * ⛔ ПЛАШКА ИСЧЕЗАЕТ САМА, КОГДА ДЕЛО СДЕЛАНО. Подписался — незачем; браузер не
 * умеет — незачем; человек запретил в настройках браузера — плашка не поможет,
 * её место занимает одна строка о том, что решение принято не здесь.
 */
export function PlashkaUvedomleniy() {
  const push = usePodpiskaNaPush();
  const [skryta, setSkryta] = useState(false);

  if (!push.dostupno || push.podpisan || skryta) return null;

  return (
    <div className="flex shrink-0 items-center gap-2 border-b border-ops-border bg-ops-primary-soft px-3 py-2">
      <IconBell size={20} className="shrink-0 text-ops-primary" />

      {/*
        ⛔ БЕЗ ПОЯСНЯЮЩЕЙ НАДПИСИ (op-rules §31.7: «экран — только рабочие поля и
        действия»). Первая редакция ставила рядом с кнопкой строку «Уведомления
        о новых обращениях выключены» — на 390 она ложилась в ТРИ строки и
        съедала у переписки семьдесят точек, не говоря ничего сверх того, что
        уже написано на самой кнопке. Осталось одно действие.

        ⛔ ЗАПРЕТ — ДРУГОЕ ДЕЛО, И ТУТ БЕЗ СЛОВ НЕЛЬЗЯ: кнопка не поможет,
        решение принимается в настройках браузера, и человек обязан узнать, где
        именно.
      */}
      {push.zapreshcheno ? (
        <span className="min-w-0 flex-1 text-ops-caption leading-snug text-ops-text">
          Уведомления запрещены в настройках браузера — включите их там
        </span>
      ) : (
        <button
          type="button"
          onClick={() => void push.pereklyuchit()}
          disabled={push.zanyat}
          className="min-w-0 flex-1 truncate rounded-ops-pill bg-ops-primary px-3 py-1.5 text-center text-ops-caption font-semibold text-ops-on-primary disabled:opacity-40"
        >
          Включить уведомления
        </button>
      )}

      {/*
        ⛔ ЗАКРЫТЬ МОЖНО, НО ТОЛЬКО ДО СЛЕДУЮЩЕГО ОТКРЫТИЯ. Памяти у крестика
        нет намеренно: пока подписки нет, вопрос не решён, и прятать его
        навсегда значит вернуть ту же тишину, ради которой плашка заведена.
      */}
      <button
        type="button"
        onClick={() => setSkryta(true)}
        aria-label="Скрыть"
        className="shrink-0 text-ops-text-tertiary hover:text-ops-text"
      >
        <IconX size={16} />
      </button>
    </div>
  );
}
